import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingSystemPages } from "@/data/roofingSystemContent";

const c = roofingSystemPages["solar-carports"];

export const Route = createFileRoute("/services/solar-carports")({
  head: () => ({
    meta: [
      { title: "Solar Carports Southern California | McKay Roofing & Solar" },
      { name: "description", content: c.heroSubtitle },
      { property: "og:title", content: "Solar Carports - McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/solar-carports" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});
